// extracted by mini-css-extract-plugin
module.exports = {"Inf_no_data":"Inf_no_data--FcmBE"};